<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :tableData="tableData"
              :isSearch="isSearch"
              @add="add"
              @pageNumChange="pageNumChange">
      <div slot="table">
        <guideImg-table :tableData="tableData.list" @update="update" @del="del"></guideImg-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import GuideImgTable from "./GuideImgTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getGuideImgList,newVue,delByGuideImgId} from "../../network/guideImg";

  export default {
    name: "GuideImgList",
    components: {GuideImgTable, MyTable},
    data(){
      return {
        title: "引导页图片列表",
        isAdd: true,
        isSearch: false,
        tableData:{},
        searchItems:{},
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/GuideImg/list";
      this.common.HeaderLocationTwo.name =  "引导页图片管理"
      this.common.HeaderLocationThree.name = "引导页图片列表"
      getGuideImgList().then(res => {
        this.tableData = res.data
      })
    },
    methods:{
      refresh(){
        getGuideImgList().then(res => {
          this.tableData = res.data
        })
      },
      pageNumChange(pageNum){
        this.getGuideImgList(pageNum).then(res => {
          this.tableData = res.data
        });
      },
      add(){
        this.$router.push("insert/");
      },
      update(id){
        this.$router.push("insert/"+id)
      },
      del(id){
        this.$confirm('此操作将永久删除该引导图, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByGuideImgId(id).then(res => {
              this.refresh()
            }
          )
        }).catch(() => {
          this.$guideImg({
            type: 'info',
            guideImg: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style scoped>

</style>
